import React from "react";
import Text from "./Text";

const Dropdown = ({ options = [], onChange, value, label }) => {
  return (
    <div>
      {label && <Text type="itemtext">{label}</Text>}
      <select className="text-2xl font-medium" value={value} onChange={(e) => onChange(e.target.value)}>
        {options.map((opt, index) => (
          <option className="text-2xl font-medium" key={index} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default Dropdown;